import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const userRole = this.authService.getRole();
    if (userRole) {
      console.log("Role Log in is...", userRole);
      
      if (userRole === 'Admin') {
        console.log("Can access")
        return true;
      }
    }
    this.router.navigate(['/login']);
    console.log("NOT access")
   return true;
  }
}
